<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/v1/10chap2#chap2">Part One</a></p>
<p class="toc2"><a href="#/v1/11chap3#chap3">1. Strongbow</a></p>
<p class="toc2"><a href="#/v1/12chap4#chap4">2. Wallenstein</a></p>
<p class="toc2"><a href="#/v1/13chap5#chap5">3. Cairo 1840</a></p>
<p class="toc2"><a href="#/v1/14chap6#chap6">4. Sinai 1836–1843</a></p>
<p class="toc2"><a href="#/v1/15chap7#chap7">5. The Haj</a></p>
<p class="toc2"><a href="#/v1/16chap8#chap8">6. YHWH</a></p>
<p class="toc2"><a href="#/v1/17chap9#chap9">7. The Tiberias Telegrams</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v1/18chap10#chap10">Part Two</a></p>
<p class="toc2"><a href="#/v1/19chap11#chap11">8. O’Sullivan Beare</a></p>
<p class="toc2"><a href="#/v1/20chap12#chap12">9. Haj Harun</a></p>
<p class="toc2"><a href="#/v1/21chap13#chap13">10. The Scarab</a></p>
<p class="toc2"><a href="#/v1/22chap14#chap14">11. Maud</a></p>
<p class="toc2"><a href="#/v1/23chap15#chap15">12. Aqaba</a></p>
<p class="toc2"><a href="#/v1/24chap16#chap16">13. Jericho</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v1/25chap17#chap17">Part Three</a></p>
<p class="toc2"><a href="#/v1/26chap18#chap18">14. Stern</a></p>
<p class="toc2"><a href="#/v1/27chap19#chap19">15. The Jordan</a></p>
<p class="toc2"><a href="#/v1/28chap20#chap20">16. Jerusalem 700 B.C.–1932</a></p>
<p class="toc2"><a href="#/v1/29chap21#chap21">17. The Bosporua</a></p>
<p class="toc2"><a href="#/v1/30chap22#chap22">18. Melchizedek 220 B.C.–1933</a></p>
<p class="toc2"><a href="#/v1/31chap23#chap23">19. Athens</a></p>
<p class="toc2"><a href="#/v1/32chap24#chap24">20. Smyrna 1922</a></p>
<p class="toc2"><a href="#/v1/33chap25#chap25">21. Cairo 1942</a></p>
<p class="toc2" style="margin-top:20px;"><a href="#/v1/34chap26#chap26">Afterword: “An Editorial Relationship” by Judy Karasik</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-TOC.vue?17d7dfd2